import React from 'react';
import { FacebookShareButton } from 'react-share';
import classNames from 'classnames';

import styles from './CarouselCard.module.scss';

const CarouselCard = ({
  title,
  type,
  shareUrl = '',
  contentExists,
  addButtonCopy,
  addButtonAction,
  existsButtonCopy,
  existsButtonAction
}) => {
  const buttonCopy = contentExists ? existsButtonCopy : addButtonCopy;
  const buttonClickAction = contentExists ? existsButtonAction : addButtonAction;

  const carouselCardClasses = classNames(styles.carouselCard, {
    [styles.event]: type === 'event',
    [styles.donation]: type === 'donation',
    [styles.obituary]: type === 'obituary',
    [styles.liveStream]: type === 'liveStream',
    [styles.facebookShare]: type === 'facebookShare'
  });

  const buttonClasses = classNames({
    [styles.exists]: !!contentExists
  });

  const facebookButtonClasses = classNames(styles.facebookShareButton, styles.exists);

  const renderButton = () => {
    return type === 'facebookShare' ? (
      <div className={facebookButtonClasses}>
        <FacebookShareButton url={shareUrl}>Post Now</FacebookShareButton>
      </div>
    ) : (
      <button className={buttonClasses} onClick={buttonClickAction}>
        {buttonCopy}
      </button>
    );
  };

  return (
    <div className={carouselCardClasses}>
      <div className={styles.cardHeader} />
      <div className={styles.cardContent}>
        <h3>{title}</h3>
        {renderButton()}
      </div>
    </div>
  );
};

export default CarouselCard;
